<template>
  <user-card
    v-if="customer"
    title="Profile"
    :username="username"
    :first="localUsername.first_name"
    :last="localUsername.last_name"
    :subtitle="customer.email"
    :avatar="customer.profile_pic"
    :edit-mode="editmode"
    :is-loading="loading"
    editable
    :style="{'min-height': '207px'}"
    @startEditing="startEditing()"
    @finnishEditing="onSubmit"
  >
    <div
      v-if="editmode"
      class="text-edit"
    >
      <base-icon
        v-if="editmode"
        class="edit-close"
        icon="check"
        @click="onSubmit"
      />

      <base-texteditable
        ref="firstName"
        v-model="localUsername.first_name"
        max-width="150px"
        placeholder="First name"
        @complete="onSubmit"
      />

      <base-texteditable
        ref="lastName"
        v-model="localUsername.last_name"
        max-width="150px"
        placeholder="Last name"
        @complete="onSubmit"
      />
    </div>
    <template
      v-if="isAdmin"
      v-slot:bottom
    >
      <div>
        <profile-selector-container :customer="customer" />
      </div>
    </template>
  </user-card>
</template>

<script>
import UserCard from './UserCard';
import ProfileSelectorContainer from './ProfileSelectorContainer';

/** WARNING: Seems deprecated. Consider deleting */

export default {
  name: 'ClientCardContainer',
  components: {
    UserCard,
    ProfileSelectorContainer,
  },
  data() {
    return {
      editmode: false,
      localUsername: {
        first_name: '',
        last_name: '',
      },
      loading: false,
    };
  },
  computed: {
    username() {
      if (this.customer.first_name || this.customer.last_name) {
        return `${this.customer.first_name} ${this.customer.last_name}`;
      }
      return '';
    },
    customer() {
      if (!this.$store.state.customers.item) {
        return {};
      }
      return this.$store.state.customers.item;
    },
    isAdmin() {
      return this.$route.state.account.isAdminMode;
    },
  },
  watch: {
    customer() {
      if (this.customer) {
        this.localUsername.first_name = this.customer.first_name;
        this.localUsername.last_name = this.customer.last_name;
      }
    },
  },
  methods: {
    startEditing() {
      this.editmode = true;
      this.$nextTick().then(() => {
        this.$refs.firstName.focus();
      });
    },
    onSubmit() {
      this.$emit('complete');
      this.editmode = false;
      this.loading = true;

      const data = {
        pk: this.$route.params.id,
        first_name: this.$refs.firstName.value,
        last_name: this.$refs.lastName.value,
      };

      this.$store.dispatch('customers/patchCustomerName', data).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>

  .user-card {
    .edit-close {
      position: absolute;
      margin-right: .5rem;
      width: 1rem;
      height: auto;
      right: 0;
    }
  }

  ::v-deep .card-body {
    display: flex;
    align-items: center;
    min-height: 162px;
  }

  .text-edit {
    display: flex;
    flex-direction: column;
    position: relative;
  }

</style>
